const colorMapping = {
  totalAssets: {
    backgroundColor: "rgba(0, 255, 127, 0.5)",
    borderColor: "rgba(0, 255, 127, 1)",
  },
  totalLiabilities: {
    backgroundColor: "rgba(255, 69, 0, 0.5)",
    borderColor: "rgba(255, 69, 0, 1)",
  },
  totalEquity: {
    backgroundColor: "rgba(75, 0, 130, 0.5)",
    borderColor: "rgba(75, 0, 130, 1)",
  },
  totalDebt: {
    backgroundColor: "rgba(0, 191, 255, 0.5)",
    borderColor: "rgba(0, 191, 255, 1)",
  },
  revenue: {
    backgroundColor: "rgba(30, 144, 255, 0.5)",
    borderColor: "rgba(30, 144, 255, 1)",
  },
  grossProfit: {
    backgroundColor: "rgba(255, 106, 86, 0.5)",
    borderColor: "rgba(255, 106, 86, 1)",
  },
  netIncome: {
    backgroundColor: "rgba(255, 159, 64, 0.5)",
    borderColor: "rgba(255, 159, 64, 1)",
  },
  eps: {
    backgroundColor: "rgba(255, 20, 147, 0.5)",
    borderColor: "rgba(255, 20, 147, 1)",
  },
};

export default colorMapping;
